import { gradientParser } from "@gqlapp/base/colorful/utils/gradientParser";
import { errorByText } from "@gqlapp/qrcode/utils";

export default function QrValueMap(values) {
  let gradient, { dataStroke, backgroundColor, background, image, paramValue, selectedIndex } = values || {}
  let { correctLevel, eyeCustom, eyeShape, eyeInner, eyeBg, color, contrastColor, data_text } = values || {}
  let { strokeWidth, size } = values || {}
  strokeWidth = strokeWidth || 0;
  let icon = values?.icon || {}, frameProps = values?.frame || {};
  let frameColor = frameProps?.color || '#000000';
  contrastColor = contrastColor || '#ffffff00';

  let length = `${data_text}`.length;

  correctLevel = errorByText(correctLevel, length, (!!icon?.enabled), !!(background?.x && background?.y));
  
  if(color?.includes('gradient')){
    let type = color?.includes('radial') ? 1: 0;
    let { orientation, colorStops } = gradientParser(color);
    let values = colorStops.map(
      ({ value, left })=>{
        left = left || 0;
        left = (typeof left === 'undefined') ? 0: left;
        left = left * 100;
        return ({ left, value })
      }
    )
    gradient = { values, type, degreeStr: orientation?.value || 90 , enabled: 1 }
  }
  
  let { style, text, text_1, text_2, fontSize, fontFamily, ...frame } = frameProps
  
  if(!text_1 && text ){
    text_1 = { text, fontSize: fontSize || 100, fontFamily: fontFamily || 'Roboto' }
  }
  
  text_1 = text_1 || { fontSize: 100, fontFamily: 'Roboto' }
  text_2 = text_2 || { fontSize: 100, fontFamily: 'Roboto' }

  if(isNumber(style) && (style = parseInt(style))){
      if(style === 0){ style = `default`; }
      else if(style < 25){ style = `frame${style}` }else { style = `circle`; }
  }


  Object.assign(frame, { icon: 0, style: style || 'default', color: frameColor, text_1, text_2 });
  
  Object.assign(icon, {
    enabled: !!(icon && icon.src) ? 1 : 0, src: icon && icon.src ? icon.src : null, scale: 33, bg: 0, size: 0
  });
  
  return Object.assign(values || {},
    {
      icon, frame, data_text, correctLevel, contrastColor,
      strokeWidth, image: image || 0, size: size || 100,
      paramValue: paramValue || [], selectedIndex: selectedIndex || 0,
      color: color || '#000000', eyeCustom: !!eyeCustom,
      gradient: gradient || { enabled: 0 },
      dataStroke: dataStroke || '#ffffff',
      backgroundColor: backgroundColor || '#ffffff'
    },
    { eyeShape: eyeShape || {
        top_left: { type: 0, color: '#000000' },
        bottom_left: { type: 0, color: '#000000' },
        top_right: { type: 0, color: '#000000' },
        other: { type: 0, color: '#000000' }}},
    { eyeInner: eyeInner || {
        top_left: { type: 0, color: '#000000' },
        bottom_left: { type: 0, color: '#000000' },
        top_right: { type: 0, color: '#000000' },
        other: { type: 0, color: '#000000' }}},
    { eyeBg: eyeBg || {
        top_left: { type: 0, color: '#0000008f' },
        bottom_left: { type: 0, color: '#0000008f' },
        top_right: { type: 0, color: '#0000008f' },
        other: { type: 0, color: '#0000008f' }}},
  );
}
